import React, { useState } from "react";
import { SearchForm } from "./SearchForm";
import { AnalysisResult } from "./AnalysisResult";
import { analyzeContent } from "../services/api";
import { Toaster } from "./ui/sonner";
import { toast } from "sonner";
import "../i18n";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Dashboard() {
  const [result, setResult] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleSearch = async (query, language) => {
    setIsLoading(true);
    setResult(null);
    try {
      const analysisData = await analyzeContent(query, language);
      setResult(analysisData);
      toast.success("Analysis Complete");
    } catch (error) {
      const msg = error.response?.data?.detail || error.message || "Unknown Error";
      toast.error(`Analysis Failed: ${msg}`);
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50/50 dark:bg-gray-950 text-gray-900 dark:text-gray-100 font-sans">
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <div className="mb-8 flex items-center justify-between">
            <Link to="/" className="inline-flex items-center text-gray-500 hover:text-primary transition-colors font-medium text-sm">
                <ArrowLeft className="w-4 h-4 mr-2" /> Back to Home
            </Link>
            <span className="font-heading font-bold text-lg text-primary tracking-tight">VeryTrust</span>
        </div>

        <motion.div 
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-10 space-y-3"
        >
          <h1 className="text-3xl md:text-4xl font-heading font-bold text-gray-900 dark:text-white">
            Verify Content Authenticity
          </h1>
          <p className="text-gray-500 dark:text-gray-400 max-w-xl mx-auto">
            Analyze claims against global verified sources to determine credibility and detect potential misinformation.
          </p>
        </motion.div>

        <SearchForm onSearch={handleSearch} isLoading={isLoading} />

        {result && <AnalysisResult result={result} />}
        
        {!result && !isLoading && (
            <div className="mt-16 text-center">
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-white dark:bg-gray-900 rounded-full border border-gray-200 dark:border-gray-800 shadow-sm text-sm text-gray-400">
                    <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
                    System Operational
                </div>
            </div>
        )}
      </div>
      <Toaster position="bottom-right" theme="system" />
    </div>
  );
}
